// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__1gY-e","textInput":"LoginForm_textInput__lwkAZ","buttonContainer":"LoginForm_buttonContainer__2M9XV","logInButton":"LoginForm_logInButton__nsnU7"};